// Modal positioning and sizing defaults for FilteringModal and useRndModal

export const MODAL_DEFAULTS = {
  initialLeft: 260,
  initialTop: 160,
  initialWidth: 780,
  minWidth: 320,
  maxWidth: 1200,
};
